// extracted by mini-css-extract-plugin
export var pharmacySummary1 = "PharmacySummary1-module--pharmacySummary1--98Jtq";
export var imageWrapper = "PharmacySummary1-module--imageWrapper--dAoF1";
export var membershipCard = "PharmacySummary1-module--membershipCard--Rs4-m";
export var contentWrapper = "PharmacySummary1-module--contentWrapper--JXjrq";